import { useCallback, useState } from 'react';

import { StorageKey } from '../../../constants';

export function useNewFeatureTooltip(key: StorageKey) {
  const isNewFeatureTooltipVisible = !localStorage.getItem(key);

  const [isTooltipOpen, setIsTooltipOpen] = useState(
    isNewFeatureTooltipVisible
  );

  const handleTooltipClose = useCallback(() => {
    localStorage.setItem(key, 'hidden');
    setIsTooltipOpen(false);
  }, [key]);

  return {
    isTooltipOpen,
    handleTooltipClose,
  };
}
